var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',[_c('transition',{attrs:{"name":"slide-fade"}},[_c('consent',{attrs:{"wftkn":_vm.wftkn,"preview":_vm.baseData.preview || 0}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }